import { render, staticRenderFns } from "./Bind.vue?vue&type=template&id=590e29be&scoped=true"
import script from "./Bind.vue?vue&type=script&lang=js"
export * from "./Bind.vue?vue&type=script&lang=js"
import style0 from "./Bind.vue?vue&type=style&index=0&id=590e29be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e29be",
  null
  
)

export default component.exports